<template>
<div class="gi-nav-infoq">
  <div class="gi-nav-infoq-container">
    <div class="gi-nav-infoq-item">
      <div class="gi-nav-infoq-logo">
        <a href="//www.infoq.com/cn" target="_blank"><img src="./assets/logo-infoq.svg" alt=""></a>
        <p>促进软件开发领域知识与创新与传播</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="sass">
$nav-container-width: 1100px
$nav-height-infoq: 36px
$nav-text: #888
$nav-text-size: 14px
$nav-bg-infoq: #e8e8e8

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.gi-nav-infoq
  display: flex
  justify-content: space-between
  background-color: $nav-bg-infoq
  height: $nav-height-infoq
  +mobile
    display: none
.gi-nav-infoq-container
  width: $nav-container-width
  margin: 0 auto
  display: flex
  height: 100%
.gi-nav-infoq-item
  align-items: center
  display: flex
  height: 100%
.gi-nav-infoq-logo
  display: flex
  height: 60%
  align-items: center
  a
    display: inline-flex
    height: 100%
  img
    height: 100%
    margin-right: 10px
  p
    font-size: $nav-text-size
    color: $nav-text

</style>
